import Vue from 'vue'
import VueFire from 'vuefire'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VueSmoothScroll from 'vue-smoothscroll'

import App from './App'

Vue.use(VueFire)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueSmoothScroll)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      name: 'home',
      path: '/home'
    },
    {
      name: 'bio',
      path: '/bio'
    },
    {
      name: 'work',
      path: '/work'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
      // new navigation.
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash

        // specify offset of the element
        if (to.hash === '#anchor2') {
          position.offset = { y: 100 }
        }
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // cords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position
    }
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  mounted () {
    scrollToSection(router.currentRoute.name)
  },
  ...App
}).$mount('#app')

let scrolling = false

function updateRoute (route) {
  router.push(route)
}

function scrollToSection (section, animate = true) {
  switch (section) {
    case 'home':
    case 'work':
    case 'bio':
      let selector = document.querySelector('#' + section)
      if (selector !== null) {
        if (!scrolling && animate) {
          vm.$SmoothScroll(selector)
        } else {
          selector.scrollIntoView()
        }
      } else {
        setTimeout(function () {
          scrollToSection(section)
        }, 3500)
      }
      break
  }
}

function sectionInViewport (e) {
  let sections = document.querySelectorAll('.section')
  let anonArr = []
  let inViewport = []

  anonArr.forEach.call(sections, function (section) {
    let sectionTop = section.offsetTop
    let sectionBottom = section.offsetTop + section.offsetHeight
    let viewportBottom = window.scrollY + window.innerHeight
    let viewportTop = window.scrollY
    let index = inViewport.indexOf(section.id)

    if ((viewportBottom > sectionTop) && (viewportTop < sectionBottom)) {
      if (index === -1) {
        inViewport.push(section.id)
      }
    } else {
      if (index > -1) {
        inViewport.splice(index, 1)
      }
    }
  })

  if (inViewport.length === 1) {
    updateRoute(inViewport[0])
  }
}

router.beforeEach((to, from, next) => {
  let section = to.name
  scrollToSection(section)
  next()
})

router.afterEach((to, from) => {
  let selector = document.querySelector('#navigation')
  let section = to.name
  var html = document.querySelector('html')
  var body = document.querySelector('body')

  if (typeof selector !== undefined && selector !== null) {
    selector.classList.remove('show')
    html.classList.remove('locked')
    body.classList.remove('locked')
  } else {
    scrollToSection(section)
  }
})

window.addEventListener('wheel', function (e) {
  scrolling = true
  sectionInViewport(e)
  clearTimeout(timeout)
  let timeout = setTimeout(function () {
    scrolling = false
  }, 350)
}, {passive: true})

window.addEventListener('touchmove', function (e) {
  scrolling = true
  sectionInViewport(e)
  clearTimeout(timeout)
  let timeout = setTimeout(function () {
    scrolling = false
  }, 350)
}, {passive: true})



// WEBPACK FOOTER //
// ./src/main.js